import { memo } from 'react';
import type { IIconProps } from '../interfaces';
import { generateGUID } from '../../services';

const CopyIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  const id = `mask-${generateGUID()}`;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id={id} fill="white">
        <path d="M20.2956 17.2536V3.75098H6.79297" />
      </mask>
      <path d="M18.7953 17.2536C18.7953 18.0822 19.467 18.7539 20.2956 18.7539C21.1242 18.7539 21.7959 18.0822 21.7959 17.2536H18.7953ZM20.2956 3.75098H21.7959C21.7959 2.92239 21.1242 2.25068 20.2956 2.25068V3.75098ZM6.79297 2.25068C5.96438 2.25068 5.29267 2.92239 5.29267 3.75098C5.29267 4.57957 5.96438 5.25127 6.79297 5.25127V2.25068ZM21.7959 17.2536V3.75098H18.7953V17.2536H21.7959ZM20.2956 2.25068H6.79297V5.25127H20.2956V2.25068Z" fill={color} mask={`url(#${id})`} />
      <path d="M4.53482 19.503V7.50064H16.5372V19.503H4.53482Z" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(CopyIcon);
